import $ from "jquery";


/**
 * Показать сообщение
 * @param {any} element селектор элемента, в кот. будет отображено сообщение
 * @param {"alert-success" | "alert-danger" | "alert-warning" | "alert-info"} alertType тип сообщения
 * @param {string} message сообщение
 * @param {string} classes css классы 
 */
export const showAlert = (element, alertType, message, classes) => {
  $(element).html(`
    <div class="alert ${alertType} alert-dismissible show fade ${classes ?? ""}" role="alert">
      ${message}
      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  `);
}